import {
  TOGGLE_MIN_MAP,
  TOGGLE_CONTROLS,
  SET_VIEW_OPTIONS,
  TOOGLE_CANVAS_DIRECTION,
  SHOW_TOOLBOX_DETAILS,
  HIDE_TOOLBOX_DETAILS,
  SET_TOOLBOX_SELECTED_MENU_ITEM,
  CLEAR_TOOLBOX_SELECTED_MENU_ITEM,
  SET_DESIGNER_SETTINGS
} from "redux/constants/flowDesigner";

const initialState = {
  viewOptions: {
    showMiniMap: false,
    showControls: true
  },
  isVerticalCanvasDirection: true,
  showToolboxDetails: false,
  toolboxSelectedMenuItem: null
};

const settings = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DESIGNER_SETTINGS:
      return {
        ...state,
        ...payload,
        showToolboxDetails: false,
        toolboxSelectedMenuItem: null
      };
    case SET_VIEW_OPTIONS:
      return {
        ...state,
        viewOptions: payload
      };
    case TOGGLE_MIN_MAP:
      return {
        ...state,
        viewOptions: { ...state.viewOptions, showMiniMap: !state.viewOptions.showMiniMap }
      };
    case TOGGLE_CONTROLS:
      return {
        ...state,
        viewOptions: { ...state.viewOptions, showControls: !state.viewOptions.showControls }
      };
    case TOOGLE_CANVAS_DIRECTION:
      return {
        ...state,
        isVerticalCanvasDirection: !state.isVerticalCanvasDirection
      };
    case SHOW_TOOLBOX_DETAILS:
      return {
        ...state,
        showToolboxDetails: true
      };
    case HIDE_TOOLBOX_DETAILS:
      return {
        ...state,
        showToolboxDetails: false
      };
    case SET_TOOLBOX_SELECTED_MENU_ITEM:
      return {
        ...state,
        toolboxSelectedMenuItem: payload
      };
    case CLEAR_TOOLBOX_SELECTED_MENU_ITEM:
      return {
        ...state,
        toolboxSelectedMenuItem: null
      };
  }
  return state;
};

export default settings;
